import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';

@Component({
  selector: 'hotspot-dialog',
  templateUrl: './hotspotDialog.component.html',
  styleUrls: ['./hotspotDialog.component.scss']
})
export class HotspotDialogComponent implements OnInit {

  private getNameRegex = new RegExp('hotspot/hotspots/(.*)(-24px)?.svg');
  private oldPrefix = 'old-';
  icons: Observable<{ name: string, path: string }[]>;

  constructor(
    private _dialogRef: MatDialogRef<HotspotDialogComponent>,
    private _http: HttpClient
  ) { }

  ngOnInit(): void {
    this.icons = this._http
      .get<string[]>(environment.assetManagerUrl + '/assets/hotspots')
      .pipe(map(fileTab => {
        return fileTab.filter(file => {
          return file.match(this.getNameRegex);
        })
        .sort((a,b)=>{
          if((a.includes(this.oldPrefix) && b.includes(this.oldPrefix)) || (!a.includes(this.oldPrefix) && !b.includes(this.oldPrefix))){
            return a.localeCompare(b)
          }
          if(a.includes(this.oldPrefix) && !b.includes(this.oldPrefix)){
            return 1;
          }        
          if(!a.includes(this.oldPrefix) && b.includes(this.oldPrefix)){
            return -1;
          }
        })
        .map(file => {
          return { name: (file.match(this.getNameRegex)[1]).replace('old-', '').replace('-24px', ''), path: environment.assetsBucketPrefix + '/' + file };
        });
      }));
  }
  onClose(icon: string): void {
    this._dialogRef.close(icon);
  }
}
